// jshint module: true

// Enable IE classNames (is-ie, is-ie9, is-ie10, is-ie11)
if (document.documentMode) {
  document.body.classList.add('is-ie');
  document.body.classList.add('is-ie' + document.documentMode);
}



// WEBPACK FOOTER //
// ./bluemountain/assets/scripts/vendor/fabrique/polyfills/enable-ie-classnames.js